import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { property } from 'underscore';

import { Overlay, Icon } from 'bv-components';
import { ScrollableContext } from 'bv-contexts';
import { hide } from '../helpers';

// Using modal classes as layout, easily replaceable
const Layout = ({
  children, component, visible, title,
}) => {
  const className = classnames('right-sidebar has-scroll-bars right-sidebar-layout', component, { visible });

  const scrollableRef = useRef();

  return (
    <div className={className} ref={scrollableRef}>
      <Overlay onClick={hide} />
      <div className="modal_wrapper">
        <div className="modal_header">
          <div className="modal_header_info_wrapper" />
          <div className="modal_title_wrapper">
            <span className="modal_title">{title}</span>
          </div>
          <span className="close">
            <Icon id="close" big active onClick={hide} />
          </span>
        </div>
        <div className="modal_contents_wrapper scrollable has-scroll-bars" id="right-sidebar-scrollable">
          <ScrollableContext.Provider value={scrollableRef}>
            <div className="modal_contents">
              {children}
            </div>
          </ScrollableContext.Provider>
        </div>
      </div>
    </div>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  visible: PropTypes.bool.isRequired,
  component: PropTypes.string.isRequired,
};

export default connect(property('rightSidebar'))(Layout);
